import { BestMatchUseCase } from '../internal/use-cases/BestMatchUseCase';

interface IBestMatchPayload {
    productId: string;
}
export class ServiceBusController {
    public getBestMatchSkuId = async (payload: IBestMatchPayload) => {
        const bestMatchUseCase = new BestMatchUseCase(payload);

        return bestMatchUseCase.execute();
    };
}
